import React from 'react';
const MALE = [{
  weight: 'FIN',
  category: '- 54 Kg / 119 lbs',
  size: '#2',
  level: '26'
}, {
  weight: 'FLY',
  category: '- 58 Kg / 128 lbs',
  size: '#3',
  level: '30'
}, {
  weight: 'BANTAM',
  category: '- 63 Kg / 139 lbs',
  size: '#3',
  level: '31'
}, {
  weight: 'FEATHER',
  category: '- 68 Kg / 159 lbs',
  size: '#3',
  level: '32'
}, {
  weight: 'LIGHT',
  category: '- 74 Kg / 163 lbs',
  size: '#3',
  level: '33'
}, {
  weight: 'WELTER',
  category: '- 80 Kg / 176 lbs',
  size: '#4',
  level: '34'
}, {
  weight: 'MIDDLE',
  category: '- 87 Kg / 192 lbs',
  size: '#4',
  level: '36'
}, {
  weight: 'HEAVY',
  category: '+ 87 Kg / 192 lbs',
  size: '#4/5',
  level: '38'
}];
const FEMALE = [{
  weight: 'FIN',
  category: '- 46 Kg / 101 lbs',
  size: '#1',
  level: '22'
}, {
  weight: 'FLY',
  category: '- 49 Kg / 108 lbs',
  size: '#2',
  level: '25'
}, {
  weight: 'BANTAM',
  category: '- 53 Kg / 117 lbs',
  size: '#2',
  level: '26'
}, {
  weight: 'FEATHER',
  category: '- 57 Kg / 126 lbs',
  size: '#3',
  level: '27'
}, {
  weight: 'LIGHT',
  category: '- 62 Kg / 137 lbs',
  size: '#3',
  level: '28'
}, {
  weight: 'WELTER',
  category: '- 67 Kg / 148 lbs',
  size: '#3',
  level: '30'
}, {
  weight: 'MIDDLE',
  category: '- 73 Kg / 161 lbs',
  size: '#3',
  level: '31'
}, {
  weight: 'HEAVY',
  category: '+ 73 Kg / 161 lbs',
  size: '#4',
  level: '32'
}];
type Row = {
  weight: string;
  category: string;
  size: string;
  level: string;
};
/**
 * Senior Level tables (male + female). Owns its own data and table markup.
 */
export function SeniorLevel() {
  return <div className="space-y-12" data-id="element-943">
      <Table title="Senior MALE (남자)" headerBg="bg-blue-600" weightBg="bg-blue-50" rows={MALE} data-id="element-944" />
      <Table title="Senior FEMALE (여자)" headerBg="bg-pink-600" weightBg="bg-pink-50" rows={FEMALE} data-id="element-945" />
    </div>;
}
function Table({
  title,
  headerBg,
  weightBg,
  rows
}: {
  title: string;
  headerBg: string;
  weightBg: string;
  rows: Row[];
}) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-946">
      <div className={`${headerBg} px-6 py-4`} data-id="element-947">
        <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-948">
          {title}
        </h2>
      </div>
      <div data-id="element-949">
        <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-950">
          <tbody data-id="element-951">
            <tr className={`border-b border-gray-200 ${weightBg}`} data-id="element-952">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-953"></td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600" data-id="element-954">
                  {item.weight}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-955">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-956">
                Category
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 text-gray-600 font-medium" data-id="element-957">
                  {item.category}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200" data-id="element-958">
              <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-959">
                Size EBP
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-960">
                  {item.size}
                </td>)}
            </tr>
            <tr className="bg-gray-50" data-id="element-961">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-962">
                LEVEL
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-963">
                  {item.level}
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}